import authHttp from './authHttp';

const healthSignin = (context, user) => {
  return new Promise((resolve, reject) => {
    authHttp.signin(context, user).then(() => {
      resolve();
    }, error => {
      reject(error);
    });
  });
};

export default {
  // api
  healthSignin
};



// WEBPACK FOOTER //
// ./src/brand/health/api/auth/index.js